import { useEffect, useState } from 'react';
import { Box, Button, Popover, badgeClasses, paperClasses } from '@mui/material';
import { post } from 'api/index.js';
// import { notifications as notificationsData } from 'data/notifications';
// import dayjs from 'dayjs';
import { useSettingsContext } from 'providers/SettingsProvider';
// import paths from 'routes/paths';
import IconifyIcon from 'components/base/IconifyIcon';
import SimpleBar from 'components/base/SimpleBar';
import NotificationList from 'components/sections/notification/NotificationList';
import OutlinedBadge from 'components/styled/OutlinedBadge';
import { useNotifications } from '../../../providers/notificationContext.jsx';

const NotificationMenu = ({ type = 'default' }) => {
  const { notifications, fetchNotification } = useNotifications();
  const [notification, setNotification] = useState({
    new: [],
    old: [],
  });

  const [anchorEl, setAnchorEl] = useState(null);

  const {
    config: { textDirection },
  } = useSettingsContext();

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // const setNotificationRead = async () => {
  //   try {
  //     const notificationIds = notification.map((notif) => notif._id);
  //     await post('users/setNotificationRead', { notificationIds });
  //   } catch (error) {
  //     console.log('error', error);
  //   }
  // };
  const handleClose = async () => {
    setAnchorEl(null);
    // setNotificationRead();
    const notificationIds = notification?.new.map((notif) => notif._id);
    await post('users/setNotificationRead', { notificationIds });
    fetchNotification();
  };

  useEffect(() => {
    if (!notifications?.length) {
      setNotification({ new: [], old: [] });
      return;
    }

    const datewiseNotification = notifications.reduce(
      (acc, val) => {
        if (val.isRead) {
          // ✅ FIX IS HERE
          acc.old.push(val);
        } else {
          acc.new.push(val);
        }
        return acc;
      },
      {
        new: [],
        old: [],
      },
    );

    setNotification(datewiseNotification);
  }, [notifications]);

  return (
    <>
      <Button
        color="neutral"
        variant={type === 'default' ? 'soft' : 'text'}
        shape="circle"
        size={type === 'slim' ? 'small' : 'medium'}
        onClick={handleClick}
      >
        {/* {notification?.new?.length > 0 ? ( */}
        <OutlinedBadge
          badgeContent={notification?.new?.length}
          color="error"
          sx={{
            [`& .${badgeClasses.badge}`]: {
              height: 18,
              width: 18,
              top: -2,
              right: -2,
              borderRadius: '50%',
              fontSize: 11,
              fontWeight: 600,
            },
          }}
        >
          <IconifyIcon
            icon={
              type === 'slim'
                ? 'material-symbols:notifications-outline-rounded'
                : 'material-symbols-light:notifications-outline-rounded'
            }
            sx={{ fontSize: type === 'slim' ? 18 : 22 }}
          />
        </OutlinedBadge>
        {/* ) : (
          <IconifyIcon
            icon={
              type === 'slim'
                ? 'material-symbols:notifications-outline-rounded'
                : 'material-symbols-light:notifications-outline-rounded'
            }
            sx={{ fontSize: type === 'slim' ? 18 : 22 }}
          />
        )} */}
      </Button>
      <Popover
        anchorEl={anchorEl}
        id="notification-menu"
        open={open}
        onClose={handleClose}
        transformOrigin={{
          horizontal: textDirection === 'rtl' ? 'left' : 'right',
          vertical: 'top',
        }}
        anchorOrigin={{
          horizontal: textDirection === 'rtl' ? 'left' : 'right',
          vertical: 'bottom',
        }}
        sx={{
          [`& .${paperClasses.root}`]: {
            width: 400,
            height: 450,
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <Box sx={{ pt: 2, flex: 1, overflow: 'hidden' }}>
          <SimpleBar disableHorizontal>
            <NotificationList
              title="New"
              notifications={notification.new}
              variant="small"
              onItemClick={handleClose}
            />
            <NotificationList
              title="Older"
              notifications={notification.old}
              variant="small"
              onItemClick={handleClose}
            />
          </SimpleBar>
        </Box>
        {/* <Stack
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
            py: 1,
          }}
        >
          <Button
            component={Link}
            underline="none"
            href={paths.notifications}
            variant="text"
            color="primary"
          >
            Load more notifications
          </Button>
        </Stack> */}
      </Popover>
    </>
  );
};

export default NotificationMenu;
